import "./App.css";
import { AppBar, Box, Container, Toolbar, Typography } from "@mui/material";
import { Route, Routes, Navigate, Link, useLocation } from "react-router-dom";
import { FaqAppContainer } from "./modules/FaqAppContainer.tsx";
import { TicketAppContainer } from "./modules/TicketAppContainer.tsx";
import { CustomerAppContainer } from "./modules/CustomerAppContainer.tsx";
import { OrganizationAppContainer } from "./modules/OrganizationAppContainer.tsx";
import { useZendeskAuth } from "./hooks/useZendeskAuth";

function App() {
  const location = useLocation();

  // Zendesk認証の設定
  const authConfig = {
    clientId: import.meta.env.VITE_ZENDESK_CLIENT_ID,
    subdomain: import.meta.env.VITE_ZENDESK_SUBDOMAIN,
    redirectUri: import.meta.env.VITE_REDIRECT_URI,
    proxyUrl: import.meta.env.VITE_PROXY_URL,
  };

  // カスタムフックで認証処理を管理
  const { accessToken, isLoggingIn, isAuthenticated } =
    useZendeskAuth(authConfig);

  const pages = [
    { name: "チケット", url: "/ticket" },
    { name: "FAQ", url: "/faq" },
    { name: "顧客", url: "/customers" },
    { name: "組織", url: "/organizations" },
  ];

  if (isAuthenticated) {
    return (
      <Container>
        <AppBar
          position="fixed"
          sx={{
            width: "100%",
            top: 0,
            backgroundColor: "#444646",
          }}
        >
          {" "}
          <Toolbar>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="h6" noWrap sx={{ mr: 3, color: "inherit" }}>
                Zendesk Impex
              </Typography>
              <Box sx={{ display: "flex", gap: 2 }}>
                {pages.map((page) => {
                  const isActive = location.pathname === page.url;

                  return (
                    <Typography
                      key={page.url}
                      sx={{
                        textAlign: "center",
                        backgroundColor: isActive ? "white" : "transparent",
                        color: isActive ? "#444646" : "white",
                        fontWeight: isActive ? "bold" : "normal",
                        borderRadius: "5px",
                        padding: "8px 16px",
                      }}
                    >
                      <Link
                        to={page.url}
                        style={{
                          color: "inherit",
                          textDecoration: "none",
                        }}
                      >
                        {page.name}
                      </Link>
                    </Typography>
                  );
                })}
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
        <Routes>
          <Route
            path="/ticket"
            element={<TicketAppContainer token={accessToken} />}
          />
          <Route
            path="/faq"
            element={<FaqAppContainer token={accessToken} />}
          />
          <Route
            path="/customers"
            element={<CustomerAppContainer token={accessToken} />}
          />
          <Route
            path="/organizations"
            element={<OrganizationAppContainer token={accessToken} />}
          />
          <Route path="*" element={<Navigate to="/ticket" />} />
        </Routes>
      </Container>
    );
  }

  // 認証処理状態をコンソールに出力
  if (isLoggingIn) {
    console.log("認証処理中...");
  } else if (!isAuthenticated) {
    console.log("Zendeskへの認証を準備しています...");
  }

  // 認証処理中のローディング表示
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        textAlign: "center",
      }}
    >
      <Typography variant="body1" sx={{ mt: 2 }}>
        認証処理中...
      </Typography>
    </Container>
  );
}

export default App;
